import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContractDocumentsEnvelopes } from 'src/app/esign/models/contract-documents-envelopes.model';
import { PortalTemplatesEnvelopes } from 'src/app/esign/models/portal-templates-envelopes.model';
import * as fromEsign from './esign-reducer';

export const selectEsignState = createFeatureSelector<fromEsign.EsignState>(fromEsign.esignFeatureKey);

export const selectError = createSelector(selectEsignState, (state: fromEsign.EsignState) => state.error);

export const selectInitLoadedEsignState = createSelector(selectEsignState, (state: fromEsign.EsignState) => {
    return {
        candidateInfo: state.candidateInfo,
        requiredDocuments: state.requiredDocuments,
        envelopes: state.envelopes,
        isCreateMode: state.isCreateMode
    } as ContractDocumentsEnvelopes;
});

export const selectPortalEsignState = createSelector(selectEsignState, (state: fromEsign.EsignState) => {
    return {
        candidateInfo: state.candidateInfo,
        envelopes: state.portalEnvelopes
    } as PortalTemplatesEnvelopes;
});

export const selectCandidateInfo = createSelector(
    selectEsignState,
    (state: fromEsign.EsignState) => state.candidateInfo
);

export const selectRequiredDocuments = createSelector(
    selectEsignState,
    (state: fromEsign.EsignState) => state.requiredDocuments
);

export const selectTemplateFolders = createSelector(
    selectEsignState,
    (state: fromEsign.EsignState) => state.templateFolders
);

export const selectSelectedFolder = createSelector(
    selectEsignState,
    (state: fromEsign.EsignState) => state.selectedFolderId
);

export const selectTemplateSearchResult = createSelector(
    selectEsignState,
    (state: fromEsign.EsignState) => state.templateSearchResult
);

export const selectTemplateSearchParameters = createSelector(
    selectEsignState,
    (state: fromEsign.EsignState) => state.templateSearchParameters
);

export const selectSelectedDocumentType = createSelector(
    selectEsignState,
    (state: fromEsign.EsignState) => state.selectedDocumentType
);

export const selectEsignDocuments = createSelector(
    selectEsignState,
    (state: fromEsign.EsignState) => state.esignDocuments
);

export const selectTemplateSearchComplete = createSelector(
    selectEsignState,
    (state: fromEsign.EsignState) => state.isTemplateSearchComplete
);

export const selectTemplateMappingAllowedRTCR = createSelector(
    selectEsignState,
    (state: fromEsign.EsignState) => state.esignPermissions?.templateMappingAllowedRTCR ?? false
);
